import React from 'react';

const SubjectDopdown = ({ setSub }) => {
  const subjects = JSON.parse(localStorage.getItem('subjects'));

  const handleChange = (e) => {
    setSub(e.target.value);
  };

  return (
    <select onChange={(e) => handleChange(e)}>
      <option value='Select'>Select</option>
      {subjects.map((subject) => (
        <option value={subject.name} key={subject.id}>
          {subject.name}
        </option>
      ))}
    </select>
  );
};

export default SubjectDopdown;
